var map = {
	"./wise-token.nl.png": "d402",
	"./wiseanswered.png": "6476",
	"./wisebeyondbitcoin.png": "a037",
	"./wisemobileapp.png": "97c3",
	"./wisesimulator.png": "c1b5",
	"./wisestats.png": "f766",
	"./wisetokenitalia.png": "c296",
	"./wisetokenswitzerland.png": "c7a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1130";